<template>
  <div class="ds-control mobile dsf-teas-doubleHundredPoints">
    <div
      class="teas-point-compositeScores"
      v-if="dataInfor.census && dataInfor.census.length > 0"
    >
      <div class="teas-point-compositeScores-first">
        <van-image
          class="img"
          :src="
            require('_teas/assets/themes/img/mBDoubleHundredPoints/icon-Comprehensive-score.png')
          "
        ></van-image>
        <div class="title">综合得分</div>
      </div>
      <div class="teas-point-compositeScores-content">
        <div 
          v-for="(censu, censuIndex) in dataInfor.census"
          :key="censuIndex"
          :class="{'noRightBorder': (dataInfor.census.length < 3 && censuIndex % dataInfor.census.length == (dataInfor.census.length - 1)) || censuIndex % 3 == 2 , 'compositeScores-more': dataInfor.census.length >= 3}"
          class="compositeScores-content-item content-item-left list-item-grow">
          
          <div class="number">{{ censu.score }}</div>
          <div class="contentTitle">{{ censu.name}}</div>
        </div>
      </div>
      <van-image
        class="bg-image"
        :src="require('_teas/assets/themes/img/mBDoubleHundredPoints/bg.png')"
      ></van-image>
    </div>
    <div class="teas-points-list-content">
      <div
        class="teas-points-list-content-first"
        v-for="(firstItem, firstIndex) in dataInfor.item"
        :key="firstIndex"
      >
        <div class="teas-points-list-content-firstTypeOne">
          <div v-if="firstItem.title" class="firstTypeOne-title" :style="{paddingTop: (dataInfor.census.length == 0 && firstIndex == 0 ? '0' : '20') + 'px'}">{{ firstItem.title }}</div>
          <div
            class="firstTypeOne-total"
            :class="'customColor' + (firstIndex % 3)"
            v-if="
              firstItem.children && firstItem.children.length != 0 && firstItem.is_total_value == '1'
            "
          >
            <div class="score">{{ firstItem.totalItem.score }}</div>
            <div class="title">{{ firstItem.totalItem.title }}</div>
          </div>

          <div
            v-if="firstItem.list && firstItem.list.length > 0"
            class="firstTypeTwo-list"
            :style="{marginTop: (firstItem.children.length != 0 && firstItem.is_total_value == '1' ? '20' : '10') + 'px'}"
            :class="'customColor' + (firstIndex % 3)"
          >
            <div
              class="firstTypeTwo-list-content"
            >
              <div
                class="firstTypeTwo-list-item "
                v-for="(firstList, firstListIndex) in firstItem.list"
                :class="{ 'noRightBorder': (firstItem.list.length < 4 && firstListIndex % firstItem.list.length == (firstItem.list.length - 1) && firstItem.is_total_value != '1') || firstListIndex % 4 == 3, 'firstTypeTwo-list-item-more': firstItem.list.length >= 4 }"
                :key="firstListIndex"
                @click="itemClick(firstList)"
              >
                <div class="score">{{ firstList.score }}</div>
                <div class="title">{{ firstList.title }}</div>
              </div>
              <div
                class="list-item-grow list-item-total"
                v-if="
                  firstItem.is_total_value == '1' && firstItem.children.length == 0
                "
              >
                <div class="item-total">
                  <span class="totalTitle">{{firstItem.totalItem.title}}:</span>
                  <span class="second-score">
                    <span class="score">{{ firstItem.totalItem.score }}</span>
                    <span class="detail"></span>
                  </span>
                  <span class="text">分</span>
                </div>
              </div>
            </div>
          </div>

          <div
            class="firstTypeOne-children"
            :style="{marginTop: (firstItem.list.length != 0 || firstItem.is_total_value == '1' ? '20' : '10') + 'px'}"
            v-if="firstItem.children && firstItem.children.length > 0"
          >
            <div
              class="firstTypeOne-children-item"
              :class="'customColor' + (firstIndex % 3)"
              v-for="(item, index) in firstItem.children"
              :key="index"
            >
              <DsfMobileTeasMbDbPointModule
                :dataItem="item"
                @moduleClickItem="moduleClickItem"
              ></DsfMobileTeasMbDbPointModule>
            </div>
          </div>
        </div>
      </div>
    </div>
    <van-popup
      v-model="show"
      class="pop"
      round
      position="bottom"
      closeable="true"
      @close="popClose"
      :style="{ height: '390px' }"
    >
      <div class="pop-content">
        <div class="title">选择操作分数</div>
        <div class="choosescore">
          <div
            class="score"
            :class="submitScore == 0.5 ? 'chooseColor' : 'defaultColor'"
            @click="clickScore(0.5)"
          >
            0.5分
          </div>
          <div
            class="score"
            :class="submitScore == 1 ? 'chooseColor' : 'defaultColor'"
            @click="clickScore(1)"
          >
            1分
          </div>
          <div
            class="score"
            :class="submitScore == 2 ? 'chooseColor' : 'defaultColor'"
            @click="clickScore(2)"
          >
            2分
          </div>
          <div
            class="score"
            :class="submitScore == 3 ? 'chooseColor' : 'defaultColor'"
            @click="clickScore(3)"
          >
            3分
          </div>
          <div
            class="score"
            :class="submitScore == 'other' ? 'chooseColor' : 'defaultColor'"
            @click="clickScore('other')"
          >
            自定义
          </div>
        </div>
        <div class="field">
          <div class="scoreField" v-show="isShowScoreField == true">
            <van-field v-model="score" type="number" placeholder="请填写分数" />
          </div>
          <div class="tareaField">
            <van-field
              v-model="reason"
              rows="1"
              type="textarea"
              placeholder="请填写理由"
            />
          </div>
        </div>

        <div class="btns">
          <div class="add" @click="clickBtn('add')">{{ addText }}</div>
          <div class="reduce" @click="clickBtn('reduce')">{{ reduceText }}</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
const testData = {
  census: [
    {
      calculationItem: "8baf55cffbda4b40a9edbe4c1af8d96b",
      dsOrder: 0,
      id: "26142931c9ea449ca0b64bcbfc17884e",
      methodValue: "1",
      name: "自定义列1",
      score: 22,
    }
  ],
  item: [
    {
      children: [],
      id: "e3859551e0ea462aaaf890efce676b2c",
      is_total_value: '1',
      list: [{
        id: "c27a5a7d4d2d4bc5937420fdcffb4878",
        is_total_value: null,
        module_text: "考核项",
        module_value: "3",
        pid: "c6416e07f03741299f1d2f0e2993f7b2",
        score: 11,
        title: "考核项1",
        _level: 3,
      }],
      module_text: '模块',
      module_value: '1',
      pid: null,
      title: "测试模块",
      totalItem: {
        id: "5baef8877a6546c6bcb6243dbfeeda8d",
        module_value: "4",
        pid: "e3859551e0ea462aaaf890efce676b2c",
        score: 47,
        title: "合计"
      },
      _level: 1
    }
  ]
};
export default dsf.component({
  name: "DsfMobileTeasMbDoubleHundredPoints",
  ctrlCaption: "双百分得分情况详情",
  mixins: [$mixins.control],
  design: {
    isMask: false,
  },
  props: {
    url: {
      type: String,
      default: "teas/mobile/classes/hundred/queryStudentDoubleHundred",
    },
    operationUrl: {
      type: String,
      default: "meta/persistData",
    },
  },

  data() {
    return {
      dataInfor: {},
      show: false,
      submitScore: "",
      isShowScoreField: false,
      score: "",
      reason: "",
      addText: "加分",
      reduceText: "减分",
      chooseItem: {}
    };
  },
  created() {
    if (this.isDesign) {
      this.dataInfor = testData;
    } else {
      this.getdata(0);
    }
  },
  methods: {
    popClose() {
      this.score = "";
      this.submitScore = "";
      this.isShowScoreField = false;
    },
    clickBtn(btn) {
      if (this.score == "") {
        if (this.submitScore == "other") {
          dsf.layer.message("请填写分数", false);
        } else {
          dsf.layer.message("请选择分数", false);
        }
        return;
      }
      // if (this.reason == "") {
      //   dsf.layer.message("请填写理由", false);
      //   return;
      // }
      var handle;
      if (btn == "add") {
        handle = {"text":"加分","value":"1"}
      } else {
        handle = {"text":"减分","value":"2"}
      }
      var url = this.operationUrl + '?classId=' + this.queryString.class_id;
      var data = {
        'teas_classes_doublehundred_score_record.name': this.queryString.name,
        'teas_classes_doublehundred_score_record.stu_id': this.queryString.stu_id,
        'teas_classes_doublehundred_score_record.item': {"text": this.chooseItem.title,"value": this.chooseItem.id},
        'teas_classes_doublehundred_score_record.handle': handle,
        'teas_classes_doublehundred_score_record.score': this.score,
        'teas_classes_doublehundred_score_record.reason': this.reason
      }
      var param = {
        namespace: 'teas.classes.doublehundred.score.record',
        pageName: 'edit',
        data: JSON.stringify(data)
      }
      const loading = dsf.layer.loading();
      this.$http
        .post(url, param)
        .done((res) => {
          if (res.success) {
            dsf.layer.message(res.message, true);
            this.getdata(1)
            this.show = false
            if (this.$listeners["operationCompleted"]) {
              this.$dispatch("operationCompleted");
            }
          } else {
            dsf.layer.message(res.message, false);
          }
        })
        .error((err) => {
          dsf.layer.message(err.message || "出错了，请重试", false);
        })
        .always(() => {
          dsf.layer.closeLoading(loading);
        });


    },
    clickScore(num) {
      if (num == "other") {
        this.isShowScoreField = true;
        this.submitScore = num;
        this.addText = "加分";
        this.reduceText = "减分";
        this.score = "";
      } else {
        this.isShowScoreField = false;
        this.submitScore = num;
        this.addText = "加" + this.submitScore + "分";
        this.reduceText = "减" + this.submitScore + "分";
        this.score = num;
      }
    },
    itemClick(item) {
      if (this.isDesign) {
        return
      }
      // 学员无法进行加减分操作
      if (this.queryString.isStu) {
        return;
      }
      if (item.score_source_value == 2) {
        dsf.layer.alert('自动获取的分数无法修改')
        return;
      }
      this.chooseItem = item;
      if (this.$listeners["itemClick"]) {
        this.$dispatch("itemClick", item);
      } else {
        this.show = true;
        this.submitScore = "0.5";
        this.score = "0.5";
        this.addText = "加" + this.submitScore + "分";
        this.reduceText = "减" + this.submitScore + "分";
        this.reason = ''
      }
    },
    moduleClickItem(item) {
      this.itemClick(item)
    },
    dealData(item) {
      for (let index = 0; index < item.length; index++) {
        var element = item[index];
        this.zhengliData(element);
      }
    },
    zhengliData(element) {
      var children = element.children;
      element.list = [];
      if (children && children.length > 0) {
        if (element.is_total_value == 1) {
          var totalItem = children.pop();
          element.totalItem = totalItem;
        }
        console.log(children)
        // 这里判断没有模块下有考核项的情况
        if (element._level == 1 && element.module_value != 1) {
          if (element.children && element.children.length > 0) {
            element.children.forEach(childrenelement => {
                element.list.push(childrenelement)
            });
            element.children = []
          }
        } else {
          for (
            let secondindex = 0;
            secondindex < children.length;
            secondindex++
          ) {
            var secondelement = children[secondindex];
            if (secondelement.module_value == 1) {
              this.zhengliData(secondelement);
            } else {
              if (secondelement.children && secondelement.children.length > 0) {
                secondelement.children.forEach(childrenelement => {
                    element.list.push(childrenelement)
                });
              }
              children.splice(secondindex, 1);
              secondindex--;
            }
          }
        }
        
      }
    },
    getdata(num) {
      if (!this.url) {
        return;
      }
      var classId = this.queryString.class_id;
      var stuId = this.queryString.stu_id;
      var loading;
      if (num == 0) {
        loading = dsf.layer.loading()
      }
      this.$http
        .get(this.url, {
          stuId,
          classId,
        })
        .done((res) => {
          if (res.success) {
            this.dealData(res.data.item);
            this.dataInfor = res.data;
            console.log(this.dataInfor);
          } else {
            dsf.layer.message(res.message, false);
          }
        })
        .error((err) => {
          dsf.layer.message(err.message || "出错了，请重试", false);
        })
        .always(() => {
          if (num == 0) {
            dsf.layer.closeLoading(loading);
          }
          
        });
    },
  },
});
</script>
